<template>
  <div class="mx-4 mb-4">
    <div class="mb-3 d-flex">
      <span class="mr-4 font-weight-bold">{{
        $l('INDEX.evg_sku_label_material_drawing_file') || '物料图稿文件'
      }}</span>
      <!-- <el-upload
        action=""
        :auto-upload="false"
        :show-file-list="false"
        :on-change="onUpload"
      >
        <el-button size="mini">新增上传</el-button>
      </el-upload> -->
      <el-button size="mini" @click="onAdd">{{
        $l('INDEX.evg_sku_label_add_upload') || '新增上传'
      }}</el-button>
    </div>
    <div>
      <div
        class="mb-2"
        v-for="(item, index) in materialImageList"
        :key="item.evgSkuMaterialImgCode || item.id"
      >
        <ArtworkItem
          :item="item"
          :index="index"
          @save="saveItem"
          @delete="deleteItem"
        />
      </div>
      <el-empty
        v-if="!materialImageList || !materialImageList.length"
        :description="$l('INDEX.tips_no_data') || '暂无数据！'"
      ></el-empty>
    </div>
  </div>
</template>
<script>
import ArtworkItem from './ArtworkItem.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: {
    ArtworkItem,
  },
  mixins: [EditLoading],
  props: {
    evgSkuMaterialCode: String,
    evgSkuCode: String,
  },
  data() {
    return {
      materialImageList: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 获取物料图稿文件
    getData() {
      this.loadingOpen()
      this.$api
        .ecomEvgSkuMaterialImageListApi({
          evgSkuMaterialCode: this.evgSkuMaterialCode,
        })
        .then(({ status, body }) => {
          if (status == 200) {
            this.materialImageList = body.data?.map((t) => ({
              ...t,
              readonly: true,
            }))
          }
          this.loadingClose()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async onUpload(file) {
      if (file.status !== 'ready') {
        return
      }
      const { status, body } = await this.$api.SYS_UPLOAD(file.raw)
      if (status != 200) {
        this.$message.error('上传失败')
        return
      }
      this.materialImageList.push({
        url: body.url,
        fileName: file.name,
        fileSize: file.size,
      })
    },
    onAdd() {
      this.materialImageList.unshift({
        id: this.getID(),
        readonly: false,
      })
    },
    async saveItem(item) {
      if (this.loadingOpen()) return
      let file = {}
      if (item.file) {
        const { status, body } = await this.$api.SYS_UPLOAD(item.file)
        if (status != 200) {
          this.$message.error(this.$l('INDEX.message_material_upload_error') || '上传失败')
          this.loadingClose()
          return
        }
        file = body || {}
      }

      await this.$api
        .ecomEvgSkuMaterialImageSaveApi({
          evgSkuMaterialImgCode: item.evgSkuMaterialImgCode,
          evgSkuMaterialCode: this.evgSkuMaterialCode,
          evgSkuCode: this.evgSkuCode,
          seqno: 1,
          sortOrder: 1,
          fileCode: file.fileId,
          fileUrl: file.url,
          fileName: item.fileName,
          fileSize: item.fileSize,
          fileDesc: item.fileDesc,
        })
        .then(({ status, body }) => {
          if (status != 200) {
            this.$message.error(
              this.$l('INDEX.message_material_save_error') || '保存失败'
            )
            this.loadingClose()
            return
          }
          this.$message.success(
            this.$l('INDEX.message_material_save_success') || '保存成功'
          )
          this.getData()
          this.loadingClose()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    deleteItem({ index }) {
      const item = this.materialImageList[index]
      if (!item) {
        return
      }

      if (!item.fileName && !item.fileDesc && !item.evgSkuMaterialImgCode) {
        this.materialImageList.splice(index, 1)
        return
      }

      this.$confirm(
        this.$l('INDEX.message_material_del_content') || '确认要删除吗？',
        this.$l('INDEX.message_material_del_title') || '提示',
        {
          confirmButtonText:
            this.$l('INDEX.message_material_del_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.message_material_del_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          if (!item.evgSkuMaterialImgCode) {
            this.materialImageList.splice(index, 1)
            return
          }
          if (this.loadingOpen()) return

          this.$api
            .ecomEvgSkuMaterialImageDelApi({
              evgSkuMaterialImgCode: item.evgSkuMaterialImgCode,
            })
            .then(({ status, body }) => {
              if (status != 200) {
                this.$message.error(
                  this.$l('INDEX.message_material_del_error') || '删除失败'
                )
                this.loadingClose()
                return
              }
              this.$message.success(
                this.$l('INDEX.message_material_del_success') || '删除成功'
              )
              this.getData()
              this.loadingClose()
            })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    /**
     * 生成一个临时ID
     */
    getID() {
      let idStr = Date.now().toString(36)
      idStr += Math.random()
        .toString(36)
        .substring(2)
      return idStr
    },
  },
}
</script>
<style scoped></style>
